import React, { Component } from 'react';
import { getIcon } from '../../../Common/Common';
import { pushCommand, isEmpty } from '../../../Common/Common';

import Av_Slider from './Components/Av_Slider';

export default class LevelOperation extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	handleChangeAV = (val) => {
		let command = 'av';
		pushCommand(command, val, this.props.point_id);
	}

	handleToggleOffTimer = (val) => {
		let command = 'off_timer';
		pushCommand(command, val, this.props.point_id);
	}

	render() {
		let icon = getIcon(this.props.point_info.icon, this.props.point_info.stat);
		let icon_width = 150;

		let op_button_cell_style = {
			width: this.props.width / 3 - 60,
			height: 120,
			margin: 10,
			padding: 10,
			backgroundColor: 'white',
			borderRadius: 20,
		}

		return (
			<div id='level_operation' >
				<div >
					<img id={'device_icon'} src={icon} alt='icon' style={{ width: icon_width }} />
				</div>
				<div style={{ marginBottom: 20 }}>
					<Av_Slider
						point_id={this.props.point_id}
						width={this.props.width}
						point_info={this.props.point_info}
						receiver={this.props.receiver}
						handleChangeVal={this.handleChangeAV}
					/>
				</div>
			</div>
		)
	}
}